export default __webpack_public_path__ + "static/media/ntu_as_logo.dd1771d0.png";